/* see country code to country name mapping at
   node_modules/react-phone-number-input/locale/en.json */

export const countriesOrder = [
  'FR',
  'LU',
  'RE', // Réunion
  'GP', // Guadeloupe
  'MQ', // Martinique
  'NC', // New Caledonia
  'GF', // French Guiana
  'BE',
  'GB',
  'DE',
  'ES',
  'NL',
  'PT',
  'IT',
  'CH',
]
